export default "__VITE_ASSET__CGdlsNxZ__"